import React, { useState, useEffect } from "react";
import { Card, Typography } from "@mui/material";
import { http } from "../../../../../clients/http/http.client";
import StatusCard from "../../../../Inputs/StatusCard/StatusCard";
import { HTTP_ENDPOINTS } from "../../../../../clients/clients.constants";
import Loader from "../../../../Inputs/Loader/Loader";
import { useSelector } from "react-redux";
import SocketClient from "../../../../../clients/socket.client";

const { ALERTS_STATISTICS } = HTTP_ENDPOINTS;

const AlertsCard = ({ type = "alertCard" }) => {
  const socket = SocketClient.getSocket();
  const [alertStats, setAlertStats] = useState({
    open: 0,
    inProgress: 0,
    close: 0,
    total: 0,
  });

  const statusChangeCount = useSelector((state) => state.updateAlertStatusAction.changedCount);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const siteIdStore = useSelector((state) => state.siteId);

  const buildSiteIdQueryParams = () => {
    let params = new URLSearchParams();

    if (siteIdStore.siteId) {
      params.append('siteId', siteIdStore.siteId);
    }

    return params.toString() ? `?${params.toString()}` : '';
  };

  useEffect(() => {
    setLoading(true);
    const filters = buildSiteIdQueryParams()
    http.client
      .get(`${ALERTS_STATISTICS}/${filters}`)
      .then((response) => {
        setAlertStats(response);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [siteIdStore]);

  useEffect(() => {
    socket.on('alertStatistics', (socketData) => {
      setAlertStats(socketData);
    });
  }, []);

  if (error) return <Typography>Error: {error}</Typography>;

  return (
    <Card className="alertsCard" sx={{ padding: "20px", boxShadow: 'none', borderRadius: "12px" }}>
      <Typography sx={{ fontSize: 22, color: "#1B3665", fontWeight: "600" }}>
        Alerts
      </Typography>
      <Typography sx={{ fontSize: 14, color: "#A0AEC0", marginBottom: "24px" }}>
        {alertStats.total} Status Alerts
      </Typography>
      {
        loading
          ? <Loader sx={{ width: "100%", height: "220px" }} />
          : <>
            <StatusCard
              status="open"
              type="alertCard"
              value={alertStats.open} // Data from API
              sx={{ marginBottom: "10px" }}
            />
            <StatusCard
              status="inProgress"
              type="alertCard"
              value={alertStats.inProgress} // Data from API
            />
            <StatusCard
              status="close"
              type="alertCard"
              value={alertStats.close} // Data from API
            />
          </>
      }
    </Card>
  );
};

export default AlertsCard;
